"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fullBleedImageSpotComponent = exports.FullBleedImageSpotComponent = void 0;
const app_1 = require("app");
const PreviewBox_1 = require("../PreviewBox/PreviewBox");
class FullBleedImageSpotComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.full-bleed-image-spot';
    }
    OnInit() {
        this.el.forEach(el => {
            this.initHeadingExternalIcon(el);
            const playButton = el.querySelector('.play-video-button');
            playButton === null || playButton === void 0 ? void 0 : playButton.addEventListener('click', function (event) {
                (0, PreviewBox_1.showPreviewBoxWithDataFromImage)(event, playButton);
            });
            playButton === null || playButton === void 0 ? void 0 : playButton.addEventListener('keypress', function (event) {
                if ((event === null || event === void 0 ? void 0 : event.key) === app_1.keyNameMapping.enter || (event === null || event === void 0 ? void 0 : event.key) === app_1.keyNameMapping.space) {
                    (0, PreviewBox_1.showPreviewBoxWithDataFromImage)(event, playButton);
                }
            });
        });
    }
    initHeadingExternalIcon(el) {
        const heading = el.querySelector('.full-bleed-image-spot__title');
        const headingLink = heading.querySelector('& > a');
        if (!heading || !headingLink) {
            return;
        }
        const externalLink = new app_1.ExternalLink();
        if (externalLink.isExternal(headingLink)) {
            externalLink.insertIcon(headingLink, 'self-center text-[length:inherit]');
        }
    }
}
exports.FullBleedImageSpotComponent = FullBleedImageSpotComponent;
exports.fullBleedImageSpotComponent = new FullBleedImageSpotComponent();
